import api from '../../../config';

const path = 'v1/messmittel/kalibrierung';

export default {
  create: (kalibrierung) => api.post(path, kalibrierung),
};
